<template>
  <organism-report></organism-report>
</template>

<script>
import OrganismReport from '@/components/organisms/portal/internal/OrganismReport.vue'

export default {
  name: "Report",
  components: { OrganismReport },
}
</script>

<style lang="scss" scoped></style>
